import React from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { type SearchQuizsetRes } from '@/api';
import { useViewport } from '@/hooks';
import { LockFillIcon } from '@/icons';
import { Chip, PublisherChip, SchoolInfoChip } from '@/shared/components/Chip/QuizInfoChip';
import { Button } from '@/ui_v3';
import { cn } from '@/utils';
import { AdditionalInfo } from './AdditionalInfo';
export interface QuizListItemProps {
  item: SearchQuizsetRes;
  subjectName?: string;
  onSelect: (quizsetId: string) => void;
}

/**
 * @deprecated 곧 컴포넌트 교체 예정입니다.
 */
export function QuizListItem(props: QuizListItemProps) {
  const {
    t
  } = useTranslation(['common', 'build']);
  const {
    isMobile
  } = useViewport();
  const lockQuiz = props.item.isLocked;
  return <div className="flex items-center justify-between gap-xl px-xs pb-lg pt-md max-mobile-lg:flex-col max-mobile-lg:items-stretch max-mobile-lg:gap-md max-mobile-lg:px-none" data-sentry-component="QuizListItem" data-sentry-source-file="QuizListItem.tsx">
      <div className={'relative flex w-full items-center gap-lg max-mobile-lg:gap-md'}>
        <div className={'flex h-[64px] w-[99px] items-center justify-center overflow-hidden max-mobile-lg:h-[48px] max-mobile-lg:w-[74px]'}>
          <img className={'size-full rounded-sm'} src={props.item.templateImageUrl} alt="bg" />
        </div>
        <div className={'flex flex-1 flex-col gap-2xs'}>
          <div className="flex flex-col justify-start gap-2xs">
            <div className={'flex gap-3xs'}>
              {props.item.categoryInfo && <SchoolInfoChip className={'text-body-sm-semibold max-tablet-lg:px-2xs max-tablet-lg:text-caption-md-semibold'} schoolInfo={props.item.categoryInfo} />}
              {props.subjectName && <Chip className={'text-body-sm-semibold max-tablet-lg:px-2xs max-tablet-lg:text-caption-md-semibold'}>
                  {props.subjectName}
                </Chip>}
              <PublisherChip className={'text-body-sm-semibold max-tablet-lg:px-2xs max-tablet-lg:text-caption-md-semibold'} hideEtc={true} publisherId={props.item.categoryInfo?.publisher} data-sentry-element="PublisherChip" data-sentry-source-file="QuizListItem.tsx" />
            </div>

            {lockQuiz && <LockFillIcon size="sm" fill={ICON_COLOR.alternative} />}
            <div className={'text-heading-md-bold'}>{props.item.title}</div>
          </div>
          <AdditionalInfo {...props.item} data-sentry-element="AdditionalInfo" data-sentry-source-file="QuizListItem.tsx" />
        </div>
      </div>

      <div className={cn('flex gap-xs items-center')}>
        <Button className="max-mobile-lg:w-full" variant="contained" intent="neutral" size={isMobile ? 'sm' : 'md'} rounded="full" asChild={true} onClick={() => {
        logger.track('previewNextQuizset', {
          from: 'selectModal'
        });
      }} data-sentry-element="Button" data-sentry-source-file="QuizListItem.tsx">
          <Link href={`/quiz/${props.item.id}`} target="_blank" data-sentry-element="Link" data-sentry-source-file="QuizListItem.tsx">
            {t('common:preview')}
          </Link>
        </Button>
        <Button className="min-w-[64px] max-mobile-lg:w-full" variant="contained" intent="strong" size={isMobile ? 'sm' : 'md'} rounded="full" disabled={lockQuiz} onClick={() => {
        logger.track('selectNextQuizset');
        props.onSelect(props.item.id);
      }} data-sentry-element="Button" data-sentry-source-file="QuizListItem.tsx">
          {lockQuiz ? t('build:nextQuizModal.lockQuiz') : t('build:nextQuizModal.select')}
        </Button>
        {/* </Conditional> */}
      </div>
    </div>;
}